// extracted by mini-css-extract-plugin
export var gif = "_bu-0";